<app-content-header [contentHeader]="contentHeader"></app-content-header>

<!-- Add button container -->
<div class="d-flex justify-content-end mb-2">
    <button class="btn btn-primary" (click)="onCreate()">
        <i data-feather="plus" class="mr-1"></i>
        Novo Modelo
    </button>
</div>

<ngx-datatable 
    class="material core-bootstrap" 
    [rowHeight]="58" 
    [limit]="basicSelectedOption" 
    columnMode="force"
    [reorderable]="false" 
    [swapColumns]="false" 
    [footerHeight]="50" 
    [headerHeight]="120"
    [loadingIndicator]="loading" 
    style="box-shadow: none" 
    [rows]="rows" 
    [scrollbarH]="false">

    <ngx-datatable-column name="Nome" prop="nome" [sortable]="false">
        <ng-template let-column="column" ngx-datatable-header-template>
            <h4>Nome</h4>
            <input type="search" placeholder="Pesquisar Nome" class="ml-25 form-control"
                (keyup)="nomeFilter($event)" />
        </ng-template>
        <ng-template ngx-datatable-cell-template let-row="row">
            <span class="font-weight-bold">{{ row.nome }}</span>
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Status" prop="flg_status" [sortable]="false">
        <ng-template let-column="column" ngx-datatable-header-template>
            <h4>Status</h4>
            <select [(ngModel)]="selectedStatus" (change)="statusFilter()"
                class="ml-25 form-control" name="" id="">
                <option [value]="0">Todos</option>
                <option [value]="1">Ativo</option>
                <option [value]="2">Inativo</option>
            </select>
        </ng-template>
        <ng-template ngx-datatable-cell-template let-row="row">
            <span class="badge badge-pill" 
                [ngClass]="{
                    'badge-light-success': row.flg_status == '1',
                    'badge-light-danger': row.flg_status == '2'
                }">
                {{row.flg_status == '1' ? 'Ativo' : 'Inativo'}}
            </span>
        </ng-template>
    </ngx-datatable-column>

    <!-- Coluna de Ações -->
    <ngx-datatable-column name="Ações" prop="acao" [width]="100" [sortable]="false">
        <ng-template ngx-datatable-cell-template let-row="row">
            <button class="btn btn-primary btn-sm btn-circle mr-1" title="editar" (click)="onEdit(row.id_rastreador_modelo)">
                <i data-feather="edit"></i>
            </button>
            <button class="btn btn-danger btn-sm btn-circle" title="excluir" (click)="onDelete(row.id_rastreador_modelo)">
                <i data-feather="trash-2"></i>
            </button>
        </ng-template>
    </ngx-datatable-column>
</ngx-datatable>
